export const FBA_SHIPPING_METHODS = ['Standard', 'Expedited', 'Priority']
export const COMMUNICATION_EMAIL = 'email'
export const COMMUNICATION_NONE = 'no_communication'
export const COMMUNICATION_PO = 'po'
export const COMMUNICATION_DROPSHIPMENT = 'dropshipment'
